import { useEffect } from 'react'
import { useAppSelector } from '@Hooks/ReduxHooks'
import { initMarketingTags } from '@Utilities/marketingTags'

/**
 * The only inter-fork difference in the marketing bootstrap: the Eduact
 * portal sets 'eduact'. Everything else is byte-identical between the portals.
 */
const BRAND = 'abwaab-plus'

/**
 * Injects GTM once the settings arrive with a container ID. Keys off the
 * slice value rather than a "settings loaded" flag: undefined (not loaded
 * yet) and null/'' (tracking off for this brand) both correctly do nothing.
 * `setEmbed` is dispatched synchronously in App's mount effect, strictly
 * before getSettings can resolve, so isEmbed is settled by the time
 * `marketing` becomes truthy. Refetches re-run the effect; the util's
 * one-shot latch makes that a no-op.
 */
export const useMarketingTags = (): void => {
	const marketing = useAppSelector(state => state.settings.marketing)
	const isEmbed = useAppSelector(state => state.utils.isEmbed)

	useEffect(() => {
		if (!marketing?.gtm_container_id) return
		initMarketingTags(marketing, { brand: BRAND, embed: isEmbed })
	}, [marketing, isEmbed])
}
